import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";


export default function Destinations({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings}) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  const [FilterHeightInvestmentProjects, setFilterHeight] = useState(688);

/*   useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [_col_id_investmentprojects]))").then(async (reply) => {
          const InvestmentProjectsNumberOfFilterRows = reply*27+40;
          console.log('InvestmentProjectsNumberOfFilterRows/Number of rows: ', InvestmentProjectsNumberOfFilterRows);
          setFilterHeight(InvestmentProjectsNumberOfFilterRows);
        }).catch(err => {
          if(!err) setError(err);
        });
      }, 500);
    });
  }, [app, err]) */

  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <h6 className="page-disclaimer"> {appDisclaimer} </h6> */}
            {/* <QlikObject
              className="page-title"
              id="ANJWBAj"
              height="35px"
              showLoader={false}
            /> */}
          </div>
          {/* <div className="col-md-2 col-sm-3 col-4">
            <QlikObject id="GqNcZ" height="35px" showLoader={false} />
          </div> */}
          {/* <div className="col-md-2 col-sm-3 col-2">
            <QlikObject
              id="VXWetj"
              height="30px"
              showLoader={false}
            />
          </div> */}
        </div>
      </div>
          
      <div className="container-fluid">

        <div className="row justify-content-start">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">


              <div className="row justify-content-left">
                {/* Charts Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">

                  <div className="row justify-content-left">
                    {/*Periods Row */}

                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                          {/* Year */}
                          <QlikCard
                            id="kGvYkEU"
                            height="36px"
                            showHeader={false}
                            showMaximize={false}
                            showExport={false}
                            showOverlayer={false}
                          />
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
                          {/* Month */}
                          <QlikCard
                            id="gtbqmkW"
                            height="36px"
                            showHeader={false}
                            showMaximize={false}
                            showExport={false}
                            showOverlayer={false}
                          />
                        </div>



                  </div>

                  <div className="row justify-content-left">
                    {/*Indicators Row */}

                        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                          {/* Text */}
                          <QlikCard
                            id="RrAvNkm"
                            height="36px"
                            showHeader={false}
                            showMaximize={false}
                            showExport={false}
                            showOverlayer={false}
                          />
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
                          {/* Indicator Selector */}
                          <QlikCard
                            id="BynFr"
                            height="36px"
                            showHeader={false}
                            showMaximize={false}
                            showExport={false}
                            showOverlayer={false}
                          />
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                          {/* Periods */}
                          <QlikCard
                            id="mnkvDw"
                            height="40px"
                            showHeader={false}
                            showMaximize={false}
                            showExport={false}
                            showOverlayer={false}
                          />
                        </div>
                  </div>

                  {/* barchart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* container */}
                      <QlikCard
                        id="GAkArn"
                        height="max(calc(100vh - 263px - 60px + 90px + 10px - 96px), 150px)"
                        showHeader={true}
                        showMaximize={false}
                        showExport={false}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>

                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  {/* map column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* map */}
                      <QlikCard
                        id="bbDUc"
                        height="max(calc(100vh - 263px - 60px + 90px + 10px), 150px)"
                        showHeader={true}
                        showMaximize={false}
                        showExport={false}
                        showPdfExport={true}
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>

          {/* <div className="row mb-2">
            <div className="col-md-2 col-sm-3 col-2">
              <QlikObject
                id="b4231dd2-2ce3-4d63-b394-838d3c6f0b0e"
                height="0px"
                showLoader={false}
              />
            </div>
          </div> */}
          
        </div>
    </section>
  );
}
